"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercialType = void 0;
var CommercialType;
(function (CommercialType) {
    CommercialType["ParalleleImportation"] = "Importation parall\u00E8le";
})(CommercialType || (exports.CommercialType = CommercialType = {}));
